/*& Models/Map/Coord
	Test
*/
export class MapCoord {
	public lat = 0
	public lng = 0

	constructor(arg?: any, lng?: any) {
		if (typeof arg === 'number') {
			this.lat = arg
			this.lng = lng
		} else if (Array.isArray(arg)) {
			this.lat = arg[0]
			this.lng = arg[1]
		} else if (typeof arg === 'object') {
			this.lat = arg.lat
			this.lng = arg.lng
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/map/mapCoord.ts